import { render, staticRenderFns } from "./add-change-app.vue?vue&type=template&id=b017e75e&scoped=true"
import script from "./add-change-app.vue?vue&type=script&lang=js"
export * from "./add-change-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b017e75e",
  null
  
)

export default component.exports